import { alpha } from '@material-ui/core';
import { Box, Button, Paper, Typography } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useTranslation } from 'react-i18next';
import CheckIcon from '@mui/icons-material/Check';

const MedicineSelectedBox = ({ medicine, onChange, type, disabled }) => {
    const { t } = useTranslation();
    const isMain = type === 'VMP';
    const colorPattern = isMain ? 'primary' : 'success';

    return (
        <Paper
            variant="outlined"
            sx={{
                width: '100%',
                p: 1.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: (theme) => alpha(theme.palette[colorPattern].main, 0.08),
                borderColor: (theme) => alpha(theme.palette[colorPattern].main, 0.2),
            }}
        >
            <Box
                Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                }}
            >
                <Box
                    sx={{
                        backgroundColor: `${colorPattern}.main`,
                        p: 0.75,
                        borderRadius: 1,
                        display: 'flex',
                    }}
                >
                    <CheckIcon size={20} color="white" />
                </Box>
                <Box>
                    <Typography
                        variant="caption"
                        sx={{
                            color: `${colorPattern}.main`,
                            fontWeight: 600,
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em',
                        }}
                    >
                        {t(isMain ? 'Generic drug' : 'Selected Product')}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            fontWeight: 600,
                            color: 'text.primary',
                        }}
                    >
                        {medicine.display}
                    </Typography>
                </Box>
            </Box>

            <Button
                variant="text"
                color={isMain ? 'error' : 'primary'}
                size="small"
                onClick={onChange}
                disabled={disabled}
                startIcon={<ClearIcon size={16} />}
                sx={{
                    fontWeight: 500,
                }}
            >
                {t(isMain ? 'Change' : 'Clear')}
            </Button>
        </Paper>
    );
};

export default MedicineSelectedBox;
